import { connect, ConnectedProps } from "react-redux";
import { PriceChangeInlineMessage } from "./component";
import { getPriceDifference, getShowPriceDecreaseMessage } from "../../reducer";
import { acknowledgePriceDifference } from "../../actions/actions";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => ({
  showPriceDecreaseMessage: getShowPriceDecreaseMessage(state),
  amount: getPriceDifference(state).fiatAmount,
});

// Dismissing the notice acknowledges the (non-blocking) price difference,
// which clears getPriceDifference.hasDifference and hides it. A later quote
// resets the acknowledgement, so a new decrease shows again.
const mapDispatchToProps = {
  acknowledgePriceDifference,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PriceChangeInlineMessageConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPriceChangeInlineMessage = connector(
  PriceChangeInlineMessage
);
